import { styles } from "./styles";

type Props = {
  headerText: string;
  extraText: string;
};

export default function ContentHeader({ headerText, extraText }: Props) {
  return (
    <styles.HeaderContainer>
      <styles.Heading> {headerText} </styles.Heading>
      <styles.ExtraText>{extraText}</styles.ExtraText>
    </styles.HeaderContainer>
  );
}
